var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.85 89.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e87722;}.cls-2{fill:#fff;}.cls-3{fill:#6ea894;}.cls-4{fill:#575756;}.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m175,66.9h-3.36l16.05-21.35-14.63-21.94h7.6l11.05,16.63,12.47-16.63h3.39l-14.3,19.02,16.22,24.27h-7.63l-12.61-18.96-14.25,18.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m84.32,23.69h-2.71s-9.29-.01-9.29-.01v.02h-4.05v43.12h7.42v-19.3h9.6c6.65,0,12.54-5.38,12.54-11.92s-6.49-11.91-13.5-11.91Zm-3.21,21.08h0s-5.42,0-5.42,0v-18.49h5.42c5.1.06,9.22,3.89,9.22,9.21s-4.12,9.22-9.22,9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m36.88,66.9h7.4L23.89,22.61h-1.8L0,66.9h3.64l8.21-16.19h17.58l7.45,16.19Zm-23.63-18.96l7.81-15.41,7.09,15.41h-14.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "151.44 26.4 151.44 23.6 121.35 23.6 121.35 66.9 151.44 66.9 151.44 64.1 128.63 64.1 128.63 47.66 144.43 47.66 144.43 44.46 128.63 44.46 128.63 26.4 151.44 26.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.21 85.51 338.31 85.51 378.95 4 246.21 4 246.21 85.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "502.85 85.51 502.85 4 378.95 4 338.31 85.51 502.85 85.51"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m276.8,63.2h-7.6V26.3h7.6v36.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 351.69,
    y1: 58.7,
    x2: 349.46,
    y2: 63.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.13 26.29 347.88 51 335.63 26.29 327.96 26.29 344.07 58.7 346.3 63.19 349.46 63.19 351.69 58.7 367.8 26.29 360.13 26.29"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m432.47,53.52c0-1.44-.51-2.54-1.52-3.31-1.01-.77-2.84-1.58-5.47-2.43-2.64-.85-4.72-1.69-6.26-2.52-4.19-2.26-6.28-5.31-6.28-9.15,0-1.99.56-3.77,1.69-5.33,1.12-1.56,2.74-2.78,4.84-3.66,2.1-.88,4.46-1.32,7.08-1.32s4.98.48,7.04,1.43c2.06.95,3.66,2.3,4.8,4.04,1.14,1.74,1.71,3.72,1.71,5.93h-7.6c0-1.69-.53-3-1.6-3.94-1.06-.94-2.56-1.41-4.49-1.41s-3.3.39-4.33,1.18c-1.03.79-1.55,1.82-1.55,3.11,0,1.2.6,2.2,1.81,3.01,1.21.81,2.99,1.57,5.33,2.28,4.33,1.3,7.48,2.91,9.45,4.84,1.98,1.93,2.97,4.33,2.97,7.2,0,3.19-1.21,5.7-3.62,7.51-2.42,1.82-5.67,2.72-9.76,2.72-2.84,0-5.42-.52-7.75-1.56-2.33-1.04-4.11-2.46-5.33-4.27-1.23-1.81-1.84-3.9-1.84-6.28h7.63c0,4.07,2.43,6.11,7.3,6.11,1.81,0,3.22-.37,4.23-1.1,1.01-.73,1.52-1.76,1.52-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m478.91,32.46h-11.3v30.74h-7.6v-30.74h-11.15v-6.16h30.06v6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m319.99,63.2h-7.6l-14.8-24.28v24.28h-7.6V26.3h7.6l14.83,24.33v-24.33h7.58v36.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 376.36,
    y: 26.3,
    width: 24.68,
    height: 6.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 376.36,
    y: 41.2,
    width: 24.68,
    height: 6.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 376.36,
    y: 57.04,
    width: 24.68,
    height: 6.16
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 331.78,
    y: -85.57,
    width: 85.51,
    height: 260.64,
    transform: "translate(329.78 419.28) rotate(-90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.750f2cc6.svg";
export { ForwardRef as ReactComponent };